"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var notifications_html_1 = __importDefault(require("./notifications.html"));
var notifications_controller_1 = __importDefault(require("./notifications.controller"));
function config($stateProvider, $urlRouterProvider) {
    $stateProvider.state("drivecoach.admin.notifications", {
        url: "/notifications",
        controller: "AdminNotificationsController",
        controllerAs: "vm",
        template: notifications_html_1.default,
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];
exports.default = angular_1.default
    .module("drivecoach.admin.notifications", [])
    .config(config)
    .controller("AdminNotificationsController", notifications_controller_1.default);
